var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferBlindButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "transparent",
    stroke: "black",
    strokeWidth: 45,
    viewBox: "0 -20 512 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M132.21 208.48c16.14 29.1 34.74 57.04 58.92 82.51 24.18 25.67 54.31 49 93.34 68.85 2.86 1.44 5.63 1.44 8.05.42 3.75-1.44 7.46-4.45 11.25-8.2 2.85-2.85 6.49-7.5 10.24-12.5 14.96-19.73 33.56-44.23 59.77-32 .59.27 1.02.58 1.61.86l87.36 50.28c.27.16.59.43.86.59 11.52 7.89 16.29 20.12 16.45 33.99 0 14.1-5.2 29.97-12.82 43.37-10.08 17.7-24.93 29.38-42.04 37.15-16.29 7.47-34.42 11.53-51.84 14.11-27.35 4.02-52.98 1.44-79.24-6.64-25.67-7.9-51.45-21.06-79.67-38.45l-2.03-1.33c-12.93-8.05-26.95-16.72-40.63-26.95-50.24-37.87-101.35-92.61-134.64-152.81C9.22 211.13-6.06 156.55 2.27 104.55c4.6-28.52 16.87-54.47 38.17-71.58C58.99 18.01 84.08 9.8 116.51 12.65c3.75.28 7.07 2.46 8.79 5.63l56.06 94.79c8.21 10.66 9.22 21.17 4.77 31.72-3.75 8.64-11.25 16.57-21.49 24.07-3.01 2.58-6.64 5.2-10.39 7.89-12.51 9.07-26.8 19.57-21.92 32l-.12-.27zM512 88.65l-91.07 121.17-7.94-52.27c-67.73-3.63-114.19 18.78-145.99 74.7-8.77-103.76 50.72-163.52 130.15-178.96L389.06 0 512 88.65z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferBlindButton);
export default __webpack_public_path__ + "static/media/transfer-blind-button.b462b69f.svg";
export { ForwardRef as ReactComponent };